import { rootApi } from '../rootApi';

export const teamProductivityMeasurementApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllTeamProductivityMeasurement: builder.query({
            query: (params) => {
                const languageId = params.languageId || 1;
                const { languageId: _, ...paramsWithoutLanguageId } = params;
                return {
                    url: 'api/teamproductivitymeasurement/getlist',
                    method: 'POST',
                    body: {
                        ...paramsWithoutLanguageId,
                        LanguageId: languageId,
                        filters: params.filters || null,
                        sorts: params.sorts || null,
                        includeFilterOptions: params.includeFilterOptions || false,
                        filterOptionsColumns: params.filterOptionsColumns || null,
                        oldRequestNumber: params.oldRequestNumber || null
                    }
                };
            },
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount,
                        filterOptions: response.data.filterOptions || null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['TeamProductivityMeasurement']
        }),

        getTeamProductivityMeasurementById: builder.query({
            query: ({ id, languageId = 1 }) => ({
                url: 'api/teamproductivitymeasurement/GetById',
                method: 'POST',
                body: { id, languageId }
            }),
            transformResponse: (response) => response?.data,
            providesTags: (result, error, { id }) => [{ type: 'TeamProductivityMeasurement', id }]
        }),

        createTeamProductivityMeasurement: builder.mutation({
            query: (data) => ({
                url: 'api/teamproductivitymeasurement/Create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['TeamProductivityMeasurement']
        }),

        updateTeamProductivityMeasurement: builder.mutation({
            query: (data) => ({
                url: 'api/teamproductivitymeasurement/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, data) => ['TeamProductivityMeasurement', { type: 'TeamProductivityMeasurement', id: data.id }]
        }),

        completeTeamProductivityMeasurement: builder.mutation({
            query: (data) => ({
                url: 'api/teamproductivitymeasurement/Complete',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, data) => ['TeamProductivityMeasurement', { type: 'TeamProductivityMeasurement', id: data.id }]
        }),

        getRequestTypeDropdown: builder.query({
            query: ({ LanguageId }) => ({
                url: 'api/teamproductivitymeasurement/GetRequestTypeDropdown',
                method: 'GET',
                params: {
                    LanguageId: LanguageId || undefined
                }
            }),
            transformResponse: (response) => response?.data || []
        }),

        getRequestBroadChannelDropdown: builder.query({
            query: ({ LanguageId }) => ({
                url: 'api/teamproductivitymeasurement/GetRequestBroadChannelDropdown',
                method: 'GET',
                params: {
                    LanguageId: LanguageId || undefined
                }
            }),
            transformResponse: (response) => response?.data || []
        }),

        getRequestSenderDropdown: builder.query({
            query: ({ LanguageId }) => ({
                url: 'api/teamproductivitymeasurement/GetRequestSenderDropdown',
                method: 'GET',
                params: {
                    LanguageId: LanguageId || undefined
                }
            }),
            transformResponse: (response) => response?.data || []
        }),

        getVorVehicleDropdown: builder.query({
            query: ({ LanguageId }) => ({
                url: 'api/teamproductivitymeasurement/GetVorVehicleDropdown',
                method: 'GET',
                params: {
                    LanguageId: LanguageId || undefined
                }
            }),
            transformResponse: (response) => response?.data || []
        }),

        getOldRequestNumberDropdown: builder.query({
            query: ({ rowCount = 100, searchText } = {}) => ({
                url: 'api/teamproductivitymeasurement/GetOldRequestNumberDropdown',
                method: 'GET',
                params: {
                    RowCount: rowCount,
                    SearchText: searchText || undefined
                }
            }),
            transformResponse: (response) => response?.data?.items || [],
            providesTags: ['TeamProductivityMeasurement'],
            keepUnusedDataFor: 0
        }),
        getPersonsByGroupDropdown: builder.query({
            query: ({ senderLookupId, languageId }) => ({
                url: 'api/teamproductivitymeasurement/GetPersonsByGroupDropdown',
                method: 'GET',
                params: {
                    senderLookupId,
                    languageId: languageId || undefined
                }
            }),
            transformResponse: (response) => response?.data?.items || []
        })
    })
});

export const {
    useGetAllTeamProductivityMeasurementQuery,
    useGetTeamProductivityMeasurementByIdQuery,
    useCreateTeamProductivityMeasurementMutation,
    useUpdateTeamProductivityMeasurementMutation,
    useCompleteTeamProductivityMeasurementMutation,
    useGetRequestTypeDropdownQuery,
    useGetRequestBroadChannelDropdownQuery,
    useGetRequestSenderDropdownQuery,
    useGetVorVehicleDropdownQuery,
    useGetOldRequestNumberDropdownQuery,
    useGetPersonsByGroupDropdownQuery,
    useLazyGetPersonsByGroupDropdownQuery
} = teamProductivityMeasurementApi;
